import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { Card } from 'primereact/card';
import { Skeleton } from 'primereact/skeleton';

const FRASES = [
    "Haz de hoy tu mejor versión.",
    "La disciplina vence al talento distraído.",
    "Trabaja en silencio, brilla con tus resultados.",
    "El esfuerzo de hoy es el éxito de mañana.",
    "Nunca te pares, nunca te conformes.",
    "Enfócate y avanza un paso cada día.",
    "Donde otros dudan, tú actúa.",
    "El trabajo duro siempre recompensa.",
    "La constancia significa progreso.",
    "Tu energía define tu día."
];

const Dashboard = () => {
    const { user, axiosInstance } = useAuth();
    const [diasDisponibles, setDiasDisponibles] = useState(null);
    const [loading, setLoading] = useState(true);
    const [tieneContrato, setTieneContrato] = useState(false);

    const [fraseMotivadora, setFraseMotivadora] = useState("");

    const fetchDatosVacacionales = async () => {
        console.log("Iniciando fetch de datos vacacionales para usuario:", user);
        console.warn("Usuario no tiene documento de identidad válido." + user?.docIdentidad);
        if (!user?.docIdentidad) {
            setLoading(false);
            return;
        }

        try {
            setLoading(true);
            // 2. BUSCAR CONTRATO ACTIVO (Validación de contrato)
            const resContrato = await axiosInstance.get(`contrato/activo/persona/${user.docIdentidad}`);
            console.log(`contrato/activo/persona/${user.docIdentidad}`);
            console.log("Respuesta contrato activo:", resContrato.data);
            const contrato = resContrato.data;

            if (contrato && contrato.id) {
                setTieneContrato(true);
                // 3. BUSCAR PERIODOS DEL RÉCORD
                const resRecord = await axiosInstance.get(`record/periodo/contrato/${contrato.id}`);
                console.log("Respuesta record periodo:", resRecord.data);
                const recordPeriodoData = resRecord.data;

                // 4. APLICAR FORMULA DE CÁLCULO CONSOLIDADO
                if (recordPeriodoData && recordPeriodoData.length > 0) {
                    const hoy = new Date();
                    hoy.setHours(0, 0, 0, 0);

                    const totalConsolidado = recordPeriodoData.reduce((acc, periodo) => {
                        // Validación: CONSOLIDADO, contrato no FINALIZADO y fecha fin ya pasó
                        if (periodo.estado === 'CONSOLIDADO' && periodo.estadoContratoLaboral !== 'FINALIZADO') {
                            // Convertimos string a fecha (asumiendo formato YYYY-MM-DD)
                            const fechaFinStr = periodo.fechaFinPeriodo;
                            const [year, month, day] = fechaFinStr.split('-').map(Number);
                            const fechaFinPeriodo = new Date(year, month - 1, day);

                            if (fechaFinPeriodo < hoy) {
                                return acc + (periodo.diasDisponibles || 0);
                            }
                        }
                        return acc;
                    }, 0);

                    setDiasDisponibles(totalConsolidado);
                } else {
                    setDiasDisponibles(0);
                }
            }
        } catch (error) {
            console.error("Error al obtener datos del dashboard:", error);
            setTieneContrato(false);
            setDiasDisponibles(0);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDatosVacacionales();
        const indiceAleatorio = Math.floor(Math.random() * FRASES.length);
        setFraseMotivadora(FRASES[indiceAleatorio]);
    }, [user, axiosInstance]);

    return (
        <div className="p-4" style={{ minHeight: '80vh' }}>

            {/* CONTENEDOR DE CARDS SUPERIORES (Responsivo) */}
            <div className="grid mb-2">

                {/* CARD DE FRASES MOTIVADORAS */}
                <div className="col-12 md:col-3">
                    <Card className="shadow-3 border-round-xl border-left-3 border-blue-600 bg-blue-10 h-full">
                        <div className="flex align-items-center">
                            <div className="flex align-items-center justify-content-center bg-blue-100 border-round mr-3" style={{ width: '5rem', height: '5rem' }}>
                                <i className="pi pi-bolt text-blue-600 text-2xl"></i>
                            </div>
                            <div className="flex-grow-1">
                                <br />
                                <span className="block text-400 font-bold mb-2 text uppercase">Inspiración del día</span>
                                <div className="text-900 font-medium italic text-xl line-height-3">
                                    "{fraseMotivadora}"
                                </div>
                                <br />
                            </div>
                        </div>
                    </Card>
                </div>

                {/* CARD DE VACACIONES 
                <div className="col-12 md:col-3">
                    <Card className="shadow-3 border-round-xl border-left-3 border-red-600 bg-red-10 h-full">
                        <div className="flex align-items-start pt-2">
                            <div className="flex-grow-1">
                                <span className="block text-400 font-bold mb-2 text uppercase">Vacaciones Disponibles</span>
                                {loading ? (
                                    <Skeleton width="4rem" height="2rem"></Skeleton>
                                ) : !tieneContrato ? (
                                    <div className="text-red-500 font-bold text-sm">Sin contrato activo</div>
                                ) : (
                                    <div className="text-900 font-bold text-4xl text-red-600">
                                        {diasDisponibles} <span className="text-lg font-normal text-500">días</span>
                                    </div>
                                )}
                            </div>
                            <div className="flex align-items-center justify-content-center bg-red-100 border-round" style={{ width: '5rem', height: '5rem' }}>
                                <i className="pi pi-calendar text-red-600 text-2xl"></i>
                            </div>
                        </div>

                        {!loading && tieneContrato && (
                            <div className="mt-3 text-sm text-400 font-italic">
                                * Solo incluye periodos consolidados
                            </div>
                        )}
                    </Card>
                </div>*/}
            </div>

            {/* CONTENIDO BIENVENIDA */}
            <div className="flex justify-content-center align-items-center" style={{ minHeight: '30vh' }}>
                <Card className="w-full md:w-6 lg:w-4 text-center surface-card p-4 shadow-4 border-round-xl">
                    <div className="flex justify-content-center mb-4">
                        <div className="p-3 border-round-circle" style={{ backgroundColor: 'var(--theme-primary)' }}>
                            <i className="pi pi-user text-4xl text-white"></i>
                        </div>
                    </div>
                    <h1 className="text-3xl font-bold text-900 mb-2">
                        Bienvenido, {
                            user?.nombres && user?.apellidos
                                ? `${user.nombres.split(' ')[0]} ${user.apellidos.split(' ')[0]}`
                                : user?.username || 'Invitado'
                        }
                    </h1>
                    <p className="text-500 text-lg m-0">Has iniciado sesión correctamente.</p>
                </Card>
            </div>
        </div>
    );
};

export default Dashboard;
